import basicController from "servicestack/basic.controller.properties";

export default class ModalController {
  constructor($uibModalInstance) {
    let $ctrl = this;
    basicController($ctrl);
    $ctrl.modal = $uibModalInstance;
    $ctrl.$dismiss = $ctrl.dismiss = $uibModalInstance.dismiss;
    $ctrl.$close = $ctrl.close = $uibModalInstance.close;
  }
}

export class ModalController2 {
  constructor($element, $transclude) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.$element = $element;
    $ctrl.$transclude = $transclude;
  }

  isSlotFilled(slot) {
    return $transclude.isSlotFilled(slot);
  }

  $maxHeight() {
    const $ctrl = this;
    return $ctrl.$pageConfig.height - 180;
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.modalContent = $ctrl.$element[0].closest(".modal-content");
    $ctrl.modalContent.id = "modal-content";
  }
}
